var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { styled } from 'styled-components';
import pluralize from 'pluralize';
import { Tooltip } from '@hn-ui/tooltips';
import { Help } from '@hn-ui/icons';
var Cell = styled.div.withConfig({ displayName: "Cell", componentId: "sc-14mwhyk" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-end;\n  font-size: 16px;\n  line-height: 24px;\n  position: relative;\n  color: ", ";\n"], ["\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-end;\n  font-size: 16px;\n  line-height: 24px;\n  position: relative;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.black40;
});
var CellLeft = styled(Cell).withConfig({ displayName: "CellLeft", componentId: "sc-pq489u" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  justify-content: flex-start;\n  margin-left: 32px;\n"], ["\n  justify-content: flex-start;\n  margin-left: 32px;\n"])));
var HelpIcon = styled(Help).withConfig({ displayName: "HelpIcon", componentId: "sc-17qpfp4" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-left: 4px;\n\n  @media (hover: hover) and (pointer: fine) {\n    &:hover {\n      cursor: pointer;\n    }\n  }\n"], ["\n  margin-left: 4px;\n\n  @media (hover: hover) and (pointer: fine) {\n    &:hover {\n      cursor: pointer;\n    }\n  }\n"])));
var createDeletedCardText = function (cardsCount, hasActiveCards) {
    var deletedCardsText = hasActiveCards
        ? "and " + cardsCount + " more " + pluralize('task', cardsCount) + " (no longer available)"
        : pluralize('task', cardsCount, true) + " no longer available";
    return deletedCardsText;
};
var createTooltipText = function (cardsCount) {
    var tooltipText = pluralize('This', cardsCount) + " " + pluralize('task', cardsCount) + " " + pluralize('was', cardsCount) + " deleted from the platform\n  by our content team and no longer available";
    return tooltipText;
};
var DeletedCards = function (_a) {
    var _b = _a.data, accuracy = _b.accuracy, cardsCount = _b.cardsCount, exerciseFinished = _b.exerciseFinished, exerciseFinishedSucc = _b.exerciseFinishedSucc, timeSpent = _b.timeSpent, hasActiveCards = _a.hasActiveCards;
    var deletedCardsText = createDeletedCardText(cardsCount, hasActiveCards);
    var tooltipText = createTooltipText(cardsCount);
    return (_jsxs(_Fragment, { children: [_jsxs(CellLeft, { children: [deletedCardsText, _jsx(Tooltip, __assign({ content: tooltipText, maxWidth: 'none' }, { children: _jsx(HelpIcon, { color: 'black70' }, void 0) }), void 0)] }, void 0), _jsx(Cell, {}, void 0), _jsx(Cell, {}, void 0), _jsx(Cell, { children: timeSpent + " min" }, void 0), _jsx(Cell, { children: exerciseFinishedSucc + "/" + exerciseFinished + " (" + accuracy + "%)" }, void 0)] }, void 0));
};
export { DeletedCards };
var templateObject_1, templateObject_2, templateObject_3;
